// src/utils/demoData.js

export const generateDemoData = () => {
    // Regioni con coordinate e numero di eventi da generare
    const regions = [
      { name: "Genova", lat: 44.4056, lng: 8.9463, count: 8 },
      { name: "Milano", lat: 45.4642, lng: 9.1900, count: 6 },
      { name: "Torino", lat: 45.0703, lng: 7.6869, count: 5 },
      { name: "Savona", lat: 44.3076, lng: 8.4801, count: 4 },
      { name: "La Spezia", lat: 44.1024, lng: 9.8240, count: 3 },
      { name: "Imperia", lat: 43.8898, lng: 8.0398, count: 3 },
      { name: "Firenze", lat: 43.7696, lng: 11.2558, count: 4 },
      { name: "Roma", lat: 41.9028, lng: 12.4964, count: 7 },
      { name: "Bologna", lat: 44.4949, lng: 11.3426, count: 3 },
      { name: "Venezia", lat: 45.4408, lng: 12.3155, count: 3 },
      { name: "Napoli", lat: 40.8518, lng: 14.2681, count: 4 }
    ];
  
    // Categorie di esempio
    const demoCategories = [
      { id: 1, name: "Concerti", color: "red" },
      { id: 2, name: "Mostre", color: "blue" },
      { id: 3, name: "Festival", color: "green" },
      { id: 4, name: "Sport", color: "yellow" },
      { id: 5, name: "Teatro", color: "purple" },
      { id: 6, name: "Gastronomia", color: "brown" }
    ];
  
    // Titoli generici degli eventi per ogni categoria
    const eventTitles = {
      1: ["Concerto Rock", "Musica dal vivo", "Jazz sotto le stelle", "Opera lirica", "Festival musicale", "Concerto sinfonico", "Esibizione band locale"],
      2: ["Mostra fotografica", "Esposizione d'arte contemporanea", "Galleria d'arte moderna", "Mostra di pittura", "Esibizione di scultura", "Mostra storica"],
      3: ["Festival del cinema", "Festival delle culture", "Festa cittadina", "Festival gastronomico", "Festival letterario", "Festival di strada"],
      4: ["Torneo di calcio", "Maratona cittadina", "Gara ciclistica", "Partita di basket", "Regata velica", "Gara podistica"],
      5: ["Spettacolo teatrale", "Commedia brillante", "Dramma storico", "Improvvisazione teatrale", "Teatro per ragazzi", "One-man show"],
      6: ["Degustazione vini", "Sagra gastronomica", "Tour culinario", "Show cooking", "Festival dello street food", "Laboratorio di cucina"]
    };
    // Descrizioni generiche per ogni categoria
    const eventDescriptions = {
        1: "Un'esperienza musicale unica nel suo genere che ti lascerà senza fiato. Artisti di talento si esibiranno dal vivo con un repertorio che spazia dai grandi classici alle composizioni più moderne e innovative. Un'occasione imperdibile per tutti gli amanti della musica.",
        2: "Una straordinaria esposizione che raccoglie opere di artisti locali e internazionali. Un percorso visivo che stimola la riflessione e invita a scoprire nuove prospettive. Perfetto per gli appassionati d'arte e per chi desidera arricchire il proprio bagaglio culturale.",
        3: "Un festival che celebra la creatività e la diversità culturale. Spettacoli, workshop, performance e molto altro in un'atmosfera vibrante e coinvolgente. Un evento per tutta la famiglia dove ogni momento è un'opportunità di scoperta e divertimento.",
        4: "Un evento sportivo che unisce competizione e spirito di squadra. Atleti di tutte le età si sfideranno in una cornice di entusiasmo e fair play. Vieni a sostenere i partecipanti e a vivere l'emozione dello sport dal vivo.",
        5: "Uno spettacolo teatrale che saprà emozionarti, farti ridere e riflettere. Attori di talento daranno vita a personaggi indimenticabili in una messa in scena curata nei minimi dettagli. Un'occasione per immergersi nell'arte della recitazione.",
        6: "Un viaggio sensoriale attraverso sapori autentici e tradizioni culinarie. Chef esperti e appassionati di gastronomia condivideranno segreti e tecniche per esaltare i migliori prodotti del territorio. Un evento che delizierà ogni palato."
      };
    
      // Luoghi generici per ogni regione
      const venues = {
        "Genova": ["Teatro Carlo Felice", "Porto Antico", "Palazzo Ducale", "Acquario", "Piazza De Ferrari", "Galleria d'Arte Moderna"],
        "Milano": ["Teatro alla Scala", "Piazza Duomo", "Castello Sforzesco", "Navigli", "Parco Sempione", "Palazzo Reale"],
        "Torino": ["Museo del Cinema", "Piazza Castello", "Parco del Valentino", "Museo Egizio", "Palazzo Madama", "Teatro Regio"],
        "Savona": ["Fortezza Priamar", "Darsena", "Pinacoteca Civica", "Lungomare", "Teatro Chiabrera", "Museo della Ceramica"],
        "La Spezia": ["Porto Mirabello", "Museo Navale", "Parco XXV Aprile", "Centro d'Arte Moderna", "Cattedrale", "Piazza Cavour"],
        "Imperia": ["Porto Maurizio", "Museo Navale", "Villa Grock", "Lungomare", "Palazzo Comunale", "Parco Urbano"],
        "Firenze": ["Palazzo Vecchio", "Galleria degli Uffizi", "Piazza della Signoria", "Giardino di Boboli", "Ponte Vecchio", "Palazzo Pitti"],
        "Roma": ["Colosseo", "Foro Romano", "Piazza Navona", "Villa Borghese", "Fontana di Trevi", "Auditorium Parco della Musica"],
        "Bologna": ["Piazza Maggiore", "Arena del Sole", "Teatro Comunale", "Palazzo Re Enzo", "MAMBO", "Auditorium Manzoni"],
        "Venezia": ["Piazza San Marco", "Teatro La Fenice", "Palazzo Grassi", "Ca' Pesaro", "Arsenale", "Fondazione Prada"],
        "Napoli": ["Teatro San Carlo", "Piazza del Plebiscito", "Castel dell'Ovo", "MADRE", "Galleria Umberto I", "Palazzo Reale"]
      };
    
      // Funzione per generare una data casuale nei prossimi 30 giorni
      const randomDate = () => {
        const now = new Date();
        const futureDate = new Date();
        futureDate.setDate(now.getDate() + Math.floor(Math.random() * 30));
        return futureDate;
      };
    
      // Genera prezzi casuali
      const randomPrice = () => {
        const basePrice = Math.floor(Math.random() * 30) + 5; // Prezzo base tra 5 e 35 euro
        if (Math.random() < 0.3) { // 30% di probabilità che sia gratis
          return "Ingresso gratuito";
        }
        return `${basePrice},00 €`;
      };
    
      // Funzione per generare immagini da placeholder
      const getRandomImage = (categoryId) => {
        const categoryImages = {
          1: ["concert1.jpg", "concert2.jpg", "concert3.jpg", "concert4.jpg"],
          2: ["exhibition1.jpg", "exhibition2.jpg", "exhibition3.jpg", "exhibition4.jpg"],
          3: ["festival1.jpg", "festival2.jpg", "festival3.jpg", "festival4.jpg"],
          4: ["sport1.jpg", "sport2.jpg", "sport3.jpg", "sport4.jpg"],
          5: ["theater1.jpg", "theater2.jpg", "theater3.jpg", "theater4.jpg"],
          6: ["food1.jpg", "food2.jpg", "food3.jpg", "food4.jpg"]
        };
        
        const images = categoryImages[categoryId] || ["default.jpg"];
        return `/demo-images/${images[Math.floor(Math.random() * images.length)]}`;
      };
    
      // Genera eventi casuali per ogni regione
      let events = [];
      let eventId = 1;
    
      regions.forEach(region => {
        for (let i = 0; i < region.count; i++) {
          // Aggiungi variazione casuale alle coordinate per distribuire gli eventi
          const latVariation = (Math.random() - 0.5) * 0.1;
          const lngVariation = (Math.random() - 0.5) * 0.1;
          
          // Scegli categorie casuali (1-3 categorie per evento)
          const numCategories = Math.floor(Math.random() * 3) + 1;
          let eventCategories = [];
          const shuffledCategoryIds = [...demoCategories.map(c => c.id)].sort(() => 0.5 - Math.random());
          
          for (let j = 0; j < numCategories; j++) {
            const category = demoCategories.find(c => c.id === shuffledCategoryIds[j]);
            if (category) eventCategories.push(category);
          }
      // Ottieni la categoria principale per determinare titolo e descrizione
      const primaryCategoryId = eventCategories[0].id;
      
      // Seleziona un titolo casuale dalla categoria
      const titleOptions = eventTitles[primaryCategoryId];
      const title = titleOptions[Math.floor(Math.random() * titleOptions.length)];
      
      // Ottieni la descrizione dalla categoria
      const description = eventDescriptions[primaryCategoryId];
      
      // Seleziona un luogo casuale dalla regione
      const regionVenues = venues[region.name];
      const venue = regionVenues[Math.floor(Math.random() * regionVenues.length)];
      
      // Crea l'evento
      const event = {
        id: eventId++,
        title: `${title} - ${region.name}`,
        description: description,
        date: randomDate(),
        latitude: region.lat + latVariation,
        longitude: region.lng + lngVariation,
        location: venue,
        city: region.name,
        price: randomPrice(),
        categories: eventCategories,
        image: getRandomImage(primaryCategoryId),
        organizer: "Finday Demo",
        website: "https://finday.demo",
        contact: "info@finday.demo",
        capacity: Math.floor(Math.random() * 500) + 100
      };
      
      events.push(event);
    }
  });

  return {
    events,
    categories: demoCategories
  };
};

// Funzione per ottenere eventi fittizi
export const getDemoEvents = () => {
  return generateDemoData().events;
};

// Funzione per ottenere categorie fittizie
export const getDemoCategories = () => {
  return generateDemoData().categories;
};
    